module.exports = __webpack_public_path__ + "img/sitma.459c7bbc.png";